// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QlFt","content":"styles_content__i9glg"};